import { createClient } from '@supabase/supabase-js';

// 본 앱과 같은 Supabase 프로젝트를 쓴다 — 계정은 한 벌이다.
// 스토리지 키는 본 앱(sb-main-auth-token)과 분리해 세션 충돌을 막는다.
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isConfigured = Boolean(url && anonKey);

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
        storageKey: 'sb-docs-auth-token',
      },
    })
  : null;
